import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@chama/ui-components/components/Icon';

import './index.css';

export default function Notification({ text, icon }) {
  return (
    <div className="Notification">
      <div className="Notification__container">
        <div className="Notification__icon">
          <Icon width={16} height={16} type={icon} iconColor="white" />
        </div>
        <div className="Notification__text">{text}</div>
      </div>
    </div>
  );
}
Notification.defaultProps = {
  icon: 'checkmark',
};
Notification.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.string,
};



// WEBPACK FOOTER //
// ../ui-components/components/Notifications/Notification/index.jsx